import {Aurelia, inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {AuthService} from './auth-service';
import {AuthTokenStorage} from './auth-token-storage';
import {FlashService} from '../flash/flash-service';

@inject(
    Aurelia,
    Router,
    AuthService,
    AuthTokenStorage,
    FlashService
)
export class AuthInterceptor
{
    constructor(aurelia,
                router,
                authService,
                authTokenStorage,
                flash
    ) {
        this.aurelia = aurelia;
        this.router = router;
        this.authService = authService;
        this.authTokenStorage = authTokenStorage;
        this.flash = flash;
    }

    async request(request)
    {
        await this.authService.refreshSession();

        if (request.headers.has('Authorization')) {
            return request;
        }

        let token = this.authTokenStorage.getAccessToken();

        if (!token) {
            if (request.credentials && request.credentials == 'omit') {
                return request;
            }

            this.aurelia.setRoot('login/login');

            throw new Error('No token set');
        }

        request.headers.set('Authorization', 'Bearer ' + token);

        return request;
    }

    responseError(error)
    {
        // This case usually happens when refresh / access token revoked (user disabled etc)
        // So something out of the ordinary happened, and it makes no sense to relogin.
        // If refresh token expired, we fail already at renewing session.
        if (error.status === 401) {
            this.authService.logoutAfterError();
        }

        throw error;
    }

}
